const PLANO_CONTABIL_GERENCIAL = {
    EBITDA: { id: 1, descricao: 'EBITDA' },
    BPA: { id: 2, descricao: 'Ativo' },
    BPP: { id: 4, descricao: 'Passivo' },
    DFCMD: { id: 8, descricao: 'Fluxo de Caixa - Método Direto' },
    DFCMI: { id: 16, descricao: 'Fluxo de Caixa - Método Indireto' },
    DMPL: { id: 32, descricao: 'Mutações do Patrimônio Líquido' },
    DRA: { id: 64, descricao: 'Abrangente' },
    DRE: { id: 128, descricao: 'Resultado' },
    DVA: { id: 256, descricao: 'Valor Adicionado' }
};

module.exports = PLANO_CONTABIL_GERENCIAL;

// Balanço Patrimonial Ativo (BPA)
// Balanço Patrimonial Passivo (BPP)
// Demonstração de Fluxo de Caixa - Método Direto (DFC-MD)
// Demonstração de Fluxo de Caixa - Método Indireto (DFC-MI)
// Demonstração das Mutações do Patrimônio Líquido (DMPL)
// Demonstração de Resultado Abrangente (DRA)
// Demonstração de Resultado (DRE)
// Demonstração de Valor Adicionado (DVA)
